<template>
  <div :class="['v-select', selectSize, invalidSelect]">
    <label v-if="label" :for="id" class="v-select-label">
      {{ label }}
    </label>

    <slot name="label" />

    <select
      class="v-select-control"
      :id="id"
      :name="name"
      :disabled="disabled"
      :required="required"
      @change="onChange"
    >
      <option
        v-for="(option, index) in options"
        :key="index"
        :value="index"
        :disabled="option.value == null"
        :selected="isSelected(option.value)"
      >
        {{ option.label }}
      </option>

      <option v-if="placeholder" :value="''" disabled :selected="!value">
        {{ placeholder }}
      </option>
    </select>

    <div
      v-if="error && typeof message === 'string'"
      class="v-select-invalid-feedback"
    >
      <span>{{ message }}</span>
    </div>
    <div
      v-if="error && Array.isArray(message)"
      class="v-select-invalid-feedback"
    >
      <span v-for="msg in message" :key="msg">
        {{ msg }}
      </span>
    </div>
  </div>
</template>

<script>
const sizes = Object.freeze({
  SM: "sm",
  MD: "md",
  LG: "lg",
  XL: "xl"
});

export default {
  name: "BaseSelect",
  props: {
    label: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Number, Object, null],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      validator: value => Object.values(sizes).includes(value),
      default: sizes.MD
    },
    error: {
      type: Boolean
    },
    message: {
      type: [String, Array],
      default: ""
    }
  },
  methods: {
    onChange(event) {
      const index = event.target.value;
      let selected = null;

      if (this.options[index] && this.options[index].value !== undefined) {
        selected = this.options[index].value;
      }

      this.$emit("input", selected);
    },
    isSelected(optionValue) {
      return this.value === optionValue;
    }
  },
  computed: {
    selectSize() {
      return `v-select-${this.size}`;
    },
    invalidSelect() {
      return this.error && "v-select-invalid";
    }
  }
};
</script>
